module.exports = __webpack_public_path__ + "static/media/ic_bookmark.141a19b9.svg";